import { Link } from 'src/elements/Link'
import { lightorange, orange, paleorange, truewhite } from 'src/styles/colors'
import { fontWeightBold } from 'src/styles/font'
import { leftArrow } from 'src/styles/mixins'
import { APP_REQUEST_INFORMATION_URL, CONTACT, SIGN_IN } from 'src/utils/routes'
import styled from 'styled-components'
import {
  ABOUT,
  DropDownMenu,
  INTREVIEW,
  MenuLink,
  SERVICE,
} from './DropDownMenu'
import { HeaderWrapper } from './HeaderWrapper'

export const GuestWideHeader = () => (
  <HeaderWrapper>
    <MenuDiv>
      <DropDownMenu {...INTREVIEW} />
      <DropDownMenu {...SERVICE} />
      <DropDownMenu {...ABOUT} />
      <MenuLink href={CONTACT} label="お問い合わせ" />
    </MenuDiv>
    <div>
      <CopyParagraph>決裁者とつながるなら「ONLY STORY」</CopyParagraph>
      <ButtonsDiv>
        <ButtonLinkWithArrow href={APP_REQUEST_INFORMATION_URL}>
          資料請求する
        </ButtonLinkWithArrow>
        <ButtonLink href={SIGN_IN}>ログインはこちら</ButtonLink>
      </ButtonsDiv>
    </div>
  </HeaderWrapper>
)

const MenuDiv = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  > * {
    margin-left: 5%;
  }
`

const CopyParagraph = styled.p`
  margin-top: -4px;
  margin-bottom: 4px;
  font-size: 10px;
  font-weight: ${fontWeightBold};
  text-align: center;
`

const ButtonsDiv = styled.div`
  display: flex;
  justify-content: center;
  > * {
    margin: 0 8px;
  }
`

const ButtonLink = styled(Link)`
  display: block;
  width: 152px;
  text-align: center;
  padding: 8px 0;
  color: ${orange};
  background-color: ${truewhite};
  font-size: 12px;
  font-weight: ${fontWeightBold};
  border: 1px solid;
  border-radius: 50px;
  :hover {
    background-color: ${paleorange};
  }
`

const ButtonLinkWithArrow = styled(ButtonLink)`
  position: relative;
  color: ${truewhite};
  background-color: ${orange};
  ${leftArrow};
  :hover {
    background-color: ${lightorange};
  }
`
